export function FormatTimeDuration(startTime, endTime) {
    var createdAt = new Date(startTime);
    var completedAt = new Date(endTime);
    var diffMs = (completedAt - createdAt); // milliseconds between now & Christmas
    var diffSec = ((diffMs % 60000) / 1000).toFixed(0); // seconds
    var diffDays = Math.floor(diffMs / 86400000); // days
    var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    var days = diffDays > 0 ? (diffDays + diffDays === 1 ? "d " : "d ") : "";
    var hours = diffHrs > 0 ? diffHrs + "h " : ""
    var mins = diffMins > 0 ? diffMins + "m " : ""
    var secs = diffSec > 0 ? diffSec + "s" : ""
    var duration = days + hours + mins + secs;
    return duration;
}


export function getTimeDifferenceText(dateString) {
    if (!dateString) return "";

    // Handle default invalid date like '0001-01-01T00:00:00'
    if (dateString === "0001-01-01T00:00:00" || dateString === "0001-01-01T00:00:00Z") return "N/A";

    // Parse the date string - if it doesn't end with 'Z', treat it as UTC
    let dateToUse = dateString;
    if (!dateString.endsWith('Z') && !dateString.includes('+') && !dateString.includes('T00:00:00')) {
        // Add 'Z' to indicate it's UTC if not already present
        dateToUse = dateString.endsWith('Z') ? dateString : dateString + 'Z';
    }

    const date = new Date(dateToUse);
    if (isNaN(date.getTime())) return "N/A"; // Additional safeguard for invalid date parsing

    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const isFuture = diffMs < 0;

    const absMs = Math.abs(diffMs);
    const seconds = Math.floor(absMs / 1000);
    const minutes = Math.floor(absMs / (1000 * 60));
    const hours = Math.floor(absMs / (1000 * 60 * 60));
    const days = Math.floor(absMs / (1000 * 60 * 60 * 24));

    if (isFuture) {
        if (seconds < 60) return "in a few seconds";
        if (minutes < 60) return `in ${minutes} minute${minutes === 1 ? "" : "s"}`;
        if (hours < 24) return `in ${hours} hour${hours === 1 ? "" : "s"}`;
        return `in ${days} day${days === 1 ? "" : "s"}`;
    }

    if (seconds < 60) return "just now";
    if (minutes < 60) return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    return `${days} day${days === 1 ? "" : "s"} ago`;
}




